import  { useEffect } from 'react';
import { loadModules } from '@esri/react-arcgis';

const Search = (props) => {
    useEffect(() => {
        loadModules(["esri/widgets/Expand","esri/widgets/Search"]).then(([Expand, Search])=>{
            const search = new Expand({
                content: new Search({
                    view: props.view
                }),
                view: props.view,
                expanded: false
            });
            props.view.ui.add(search, "top-right");
        }).catch((err) => console.error(err));
    }, [props]);
    return null;
}

export default Search;